// Note: cart.js, mm.js, and modal.js are loaded separately in scripts.liquid
// jQuery is loaded globally before this script
// Sync trigger update

// Debounce accordion clicks to prevent rapid-fire toggling
let accordionClickTimeout = null;
const ACCORDION_DEBOUNCE_MS = 150;

// Use event delegation so accordion handlers work for dynamically added elements (e.g., mobile filters)
jQuery(document).on('click', '.js-trigger', function (e) {
  // CRITICAL: Stop propagation early to prevent Yotpo or other scripts from interfering
  e.stopPropagation();
  e.stopImmediatePropagation();
  // Don't prevent default for accordions - they're not links, just divs/buttons
  
  // Debounce rapid clicks
  if (accordionClickTimeout) {
    clearTimeout(accordionClickTimeout);
  }
  
  const $button = jQuery(this);
  
  // Prevent multiple simultaneous clicks on the same button
  if ($button.data('accordion-processing')) {
    return false;
  }
  $button.data('accordion-processing', true);
  
  accordionClickTimeout = setTimeout(function() {
    $button.removeData('accordion-processing');
  }, ACCORDION_DEBOUNCE_MS);
  const panelId = $button.attr('aria-controls');
  const $panel = panelId ? jQuery(`#${panelId}`) : $button.next('.accordion-body');
  
  // CRITICAL: Use button state as the SINGLE source of truth
  // Read button state BEFORE any modifications
  // Check data attribute first (most reliable), then aria-expanded attribute
  let currentAriaExpanded = $button.data('accordion-state') || $button[0].dataset.accordionState || $button.attr('aria-expanded') || 'false';
  
  // Normalize to string 'true' or 'false'
  if (currentAriaExpanded === true || currentAriaExpanded === 'true' || currentAriaExpanded === 'True') {
    currentAriaExpanded = 'true';
  } else {
    currentAriaExpanded = 'false';
  }
  
  // Sync open class with aria-expanded BEFORE calculating state
  // This ensures visual state matches the actual state
  const hasOpenClass = $button.hasClass('open');
  if ((currentAriaExpanded === 'true' && !hasOpenClass) || (currentAriaExpanded === 'false' && hasOpenClass)) {
    // Sync the open class with aria-expanded
    if (currentAriaExpanded === 'true') {
      $button[0].classList.add('open');
      $button.addClass('open');
    } else {
      $button[0].classList.remove('open');
      $button.removeClass('open');
    }
  }
  
  // Calculate new state: toggle from current state
  const isExpanded = currentAriaExpanded === 'true';
  const newState = !isExpanded;
  
  const buttonId = $button.attr('id') || '';
  const isMobileFilter = buttonId.includes('-mobile');
  
  // CRITICAL: For mobile filter accordions, ensure they start closed
  // Something might be setting them to expanded before the click
  if (isMobileFilter && isExpanded) {
    console.log('Mobile filter button was already expanded - will toggle to closed:', buttonId);
  }

  console.log('Accordion clicked:', {
    button: $button[0],
    panelId: panelId,
    panel: $panel[0],
    panelLength: $panel.length,
    currentAriaExpanded: currentAriaExpanded,
    hasOpenClass: hasOpenClass,
    computedDisplay: $panel.length ? window.getComputedStyle($panel[0]).display : 'N/A',
    ariaHidden: $panel.length ? $panel.attr('aria-hidden') : 'N/A',
    isExpanded: isExpanded,
    newState: newState
  });

  // Update button state - CRITICAL: Convert boolean to string for aria-expanded
  // Use native setAttribute to ensure it's set correctly
  const newStateString = newState ? 'true' : 'false';
  $button[0].setAttribute('aria-expanded', newStateString);
  $button.attr('aria-expanded', newStateString); // Also set via jQuery for compatibility
  
  // Explicitly add/remove open class instead of toggleClass to ensure it works
  if (newState) {
    $button.addClass('open');
  } else {
    $button.removeClass('open');
  }
  
  // Store state in data attribute as backup (more reliable than attributes)
  $button.data('accordion-state', newStateString);
  $button[0].dataset.accordionState = newStateString;
  
  // Verify button state was updated correctly
  const updatedAriaExpanded = $button.attr('aria-expanded');
  const updatedHasOpenClass = $button.hasClass('open');
  if (updatedAriaExpanded !== newStateString || updatedHasOpenClass !== newState) {
    console.warn('Button state update failed!', {
      expected: { ariaExpanded: newStateString, hasOpenClass: newState },
      actual: { ariaExpanded: updatedAriaExpanded, hasOpenClass: updatedHasOpenClass }
    });
    // Force update again using multiple methods
    $button[0].setAttribute('aria-expanded', newStateString);
    $button.attr('aria-expanded', newStateString);
    if (newState) {
      $button[0].classList.add('open');
      $button.addClass('open');
    } else {
      $button[0].classList.remove('open');
      $button.removeClass('open');
    }
  }

  if ($panel.length) {
    // Update panel ARIA state FIRST
    const ariaHiddenValue = (!newState).toString();
    $panel[0].setAttribute('aria-hidden', ariaHiddenValue);
    $panel.attr('aria-hidden', ariaHiddenValue);
    
    // For footer accordions, always force display state immediately
    const isFooterAccordion = panelId && panelId.startsWith('footer-accordion-');
    if (isFooterAccordion) {
      // CRITICAL: Force display state immediately with !important to override any CSS
      if (newState) {
        $panel[0].style.setProperty('display', 'block', 'important');
        $panel[0].style.setProperty('visibility', 'visible', 'important');
        $panel[0].style.setProperty('height', 'auto', 'important');
        $panel[0].style.setProperty('overflow', 'visible', 'important');
      } else {
        $panel[0].style.setProperty('display', 'none', 'important');
        $panel[0].style.setProperty('visibility', 'hidden', 'important');
        $panel[0].style.setProperty('height', '0', 'important');
        $panel[0].style.setProperty('overflow', 'hidden', 'important');
      }
      console.log('Panel ' + (newState ? 'opened' : 'closed') + ' (footer):', $panel[0], 'Display:', window.getComputedStyle($panel[0]).display, 'Aria-hidden:', $panel.attr('aria-hidden'));
    } else {
      // For non-footer accordions, remove inline styles first to let CSS handle it
      $panel[0].style.removeProperty('display');
      // Force a reflow to ensure CSS rules are applied
      $panel[0].offsetHeight;
      // Then ensure state is correct
      if (newState) {
        $panel[0].style.setProperty('display', 'block', 'important');
      } else {
        $panel[0].style.setProperty('display', 'none', 'important');
      }
      console.log(newState ? 'Panel opened:' : 'Panel closed:', $panel[0], 'Display:', window.getComputedStyle($panel[0]).display);
    }

    if (newState) {
      setTimeout(function () {
        const focusSelectors = '[data-accordion-focus="true"], p, li, a, button, input, textarea, select';
        let $focusTarget = $panel.find(focusSelectors).filter(':visible').first();

        if (!$focusTarget.length) {
          $focusTarget = $panel;
        }

        const hadTabindex = $focusTarget.is('[tabindex]');
        if (!hadTabindex) {
          $focusTarget.attr('tabindex', '-1').attr('data-temp-tabindex', 'true');
        }

        $focusTarget.focus({ preventScroll: false });

        $focusTarget.one('blur', function () {
          if (!hadTabindex) {
            jQuery(this).removeAttr('tabindex').removeAttr('data-temp-tabindex');
          }
        });
      }, 50);
    } else {
      $panel.removeAttr('tabindex');
      $panel.find('[data-temp-tabindex="true"]').removeAttr('tabindex data-temp-tabindex');
    }
  }
});

const focusableSelector = 'a[href], area[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function setupMegaMenu() {
  const menuItems = Array.from(document.querySelectorAll('[data-megamenu-item]'));
  if (!menuItems.length) return;

  // CRITICAL: Move ALL panels to body during initialization
  // This ensures they're completely independent from the start
  // Panels should NEVER be in the header/nav structure - only in body
  menuItems.forEach((item) => {
    const trigger = item.querySelector('[data-megamenu-trigger]');
    if (!trigger) return;
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (panel && panel.parentElement !== document.body) {
      // Store original parent
      if (!panel.dataset.originalParent) {
        panel.dataset.originalParent = panel.parentElement.tagName + (panel.parentElement.className ? '.' + panel.parentElement.className.split(' ')[0] : '');
      }
      // Move to body immediately - panels should always be in body
      document.body.appendChild(panel);
      // CRITICAL: Set tabindex="-1" on panel to remove it from tab order
      // The panel itself should not be focusable - only its children should be
      panel.setAttribute('tabindex', '-1');
      console.log('setupMegaMenu: Moved panel', panelId, 'to body. Original parent:', panel.dataset.originalParent);
    } else if (panel) {
      // Panel already in body, but ensure it has tabindex="-1"
      panel.setAttribute('tabindex', '-1');
    }
  });

  const isDesktop = () => window.matchMedia('(min-width: 769px)').matches;
  let openItem = null;
  
  // Function to get header element
  const getHeader = () => {
    return document.querySelector('header[data-site-header]') || 
           document.querySelector('header') ||
           document.querySelector('.header-container') ||
           document.querySelector('.header-main');
  };

  const isElementVisible = (el) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    return (
      (rect.width > 0 || rect.height > 0) &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity) > 0 &&
      !el.hasAttribute('hidden') &&
      !el.classList.contains('hidden')
    );
  };

  const getPanelFocusableElements = (panel) => {
    if (!panel) return [];
    const comprehensiveSelector = 'a[href], area[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.from(panel.querySelectorAll(comprehensiveSelector)).filter((el) => {
      if (el === panel) return false;
      let parent = el.parentElement;
      while (parent && parent !== panel && parent !== document.body) {
        const parentStyle = window.getComputedStyle(parent);
        if (
          parentStyle.display === 'none' ||
          parentStyle.visibility === 'hidden' ||
          parent.classList.contains('hidden') ||
          parent.hasAttribute('hidden')
        ) {
          return false;
        }
        parent = parent.parentElement;
      }
      return isElementVisible(el);
    });
  };

  const getHeaderNavFocusables = () => {
    const header = getHeader();
    if (!header) return [];
    const nav = header.querySelector('.header-nav') || header;
    return Array.from(nav.querySelectorAll(focusableSelector)).filter(isElementVisible);
  };

  const restorePanelFocusableTabOrder = (panel) => {
    if (!panel) return;
    panel.querySelectorAll('[data-original-tabindex]').forEach((el) => {
      if (el.dataset.originalTabindex === 'none') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', el.dataset.originalTabindex);
      }
      delete el.dataset.originalTabindex;
    });
    panel.querySelectorAll('a[href][tabindex="-1"], button[tabindex="-1"]').forEach((el) => {
      if (!el.dataset.originalTabindex) {
        el.removeAttribute('tabindex');
      }
    });
  };

  const announceNavMenu = (message) => {
    const liveRegion = document.querySelector('[data-nav-menu-live]');
    if (!liveRegion) return;
    liveRegion.textContent = '';
    requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
  };
  
  // Function to set header background (white when menu open, transparent when closed)
  // Also sets text/logo colors appropriately
  const setHeaderBackground = (isOpen) => {
    const header = getHeader();
    if (!header) return;
    
    // CRITICAL: Check if mobile menu is open - if so, always use white background
    const mobileMenuOpen = document.body.classList.contains('mm--open') || 
                          (document.getElementById('mobile-menu-drawer') && 
                           document.getElementById('mobile-menu-drawer').getAttribute('aria-hidden') === 'false');
    
    if (mobileMenuOpen) {
      isOpen = true;
    }
    
    // CRITICAL: Check if header is engaged (megamenu open or hovered) OR if any menu is actually open
    // This ensures header stays white when header is engaged or menu flyout is open
    // NOTE: panel-has-focus class is kept for visual indicator but doesn't mean menu is engaged
    // Only check if menus are actually open or if focus is in a panel
    if (!isOpen) {
      // Check if any menu item is open
      const anyMenuOpen = Array.from(document.querySelectorAll('[data-megamenu-item]')).some((item) => {
        return item.classList.contains('is-open') || item.classList.contains('open');
      });
      
      // Check if focus is in any panel
      const activeElement = document.activeElement;
      const anyPanelFocused = Array.from(document.querySelectorAll('[id*="-panel"]')).some((panel) => {
        return panel.contains(activeElement);
      });
      
      // Check if any panel is visible (menu flyout is open)
      // CRITICAL: Check multiple ways to ensure we catch all open panels
      const allPanels = Array.from(document.querySelectorAll('[id*="-panel"], [data-megamenu-panel], .megamenu'));
      const anyPanelVisible = allPanels.some((panel) => {
        // Check aria-hidden attribute first (most reliable)
        const ariaHidden = panel.getAttribute('aria-hidden');
        if (ariaHidden === 'false') {
          return true;
        }
        
        // Check computed styles
        const style = window.getComputedStyle(panel);
        const isDisplayed = style.display !== 'none';
        const isVisible = style.visibility !== 'hidden';
        const isOpaque = style.opacity !== '0';
        const isInViewport = panel.offsetWidth > 0 && panel.offsetHeight > 0;
        
        // Panel is visible if all these conditions are met
        return isDisplayed && isVisible && isOpaque && isInViewport;
      });
      
      // Check if mouse is over any panel (even if not over header)
      const anyPanelHovered = allPanels.some((panel) => {
        return panel.matches(':hover') || panel.querySelector(':hover') !== null;
      });
      
      // Check if header is being hovered (header is engaged)
      const headerHovered = header.matches(':hover') || header.querySelector(':hover') !== null;
      
      // If any menu is open, focus is in a panel, panel is visible, panel is hovered, or header is hovered, keep white background
      // CRITICAL: Panel visibility/hover takes priority - if flyout is open, header stays white
      if (anyMenuOpen || anyPanelFocused || anyPanelVisible || anyPanelHovered || headerHovered) {
        isOpen = true;
      }
    }
    
    const headerContainer = header.closest('.header-container') || document.querySelector('.header-container');
    const headerMain = header.querySelector('.header-main') || document.querySelector('.header-main');
    const headerNav = header.querySelector('.header-nav') || document.querySelector('.header-nav');
    
    const allHeaderElements = [header, headerContainer, headerMain, headerNav].filter(Boolean);
    
    // Check if page has image background (hero bleed root exists = transparent header when closed)
    // If hero-bleed-root exists, page has image background (like homepage) = transparent header
    // If hero-bleed-root doesn't exist, page has no image = white header
    // Exception: Locker room feature pages should always use white header with black logo
    const isLockerRoomFeature = document.querySelector('[data-locker-room-feature="true"]') !== null;
    const hasImageBackground = !isLockerRoomFeature && document.querySelector('[data-hero-bleed-root="true"]') !== null;
    
    // Check if contrast mode is enabled - if so, always use white header
    const contrastMode = document.documentElement.getAttribute('data-contrast-mode');
    const isContrastModeEnabled = contrastMode && contrastMode !== 'off';
    
    // Determine which state to use:
    // - If contrast mode is enabled: always white
    // - If menu is open: always white
    // - If menu is closed: white if no image background, transparent if image background
    const shouldUseWhiteBackground = isContrastModeEnabled || isOpen || !hasImageBackground;
    
    // Debug logging
    console.log('setHeaderBackground:', {
      isOpen,
      hasImageBackground,
      shouldUseWhiteBackground,
      logoShouldBe: shouldUseWhiteBackground ? 'dark' : 'white',
      hamburgerShouldBe: shouldUseWhiteBackground ? 'black' : 'white'
    });
    
    // Get all text elements that need color changes
    const headerLinks = header.querySelectorAll('a, .header-nav a, nav a, [data-megamenu-trigger]');
    const headerText = header.querySelectorAll('.header-logo, .header-nav, nav, [class*="logo"]');
    
    // Get search and bag elements specifically
    const searchElements = header.querySelectorAll('.header-search, .header-search-form, .header-search-input, .header-search-button, .header-search-icon, [class*="search"]');
    const bagElements = header.querySelectorAll('.header-bag-button, .header-bag-icon, .header-bag-text, [class*="bag"], [class*="cart"]');
    
    // Get or create style element for placeholder colors
    let styleEl = document.getElementById('header-menu-color-override');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'header-menu-color-override';
      document.head.appendChild(styleEl);
    }
    
    if (shouldUseWhiteBackground) {
      header.setAttribute('data-header-bg', 'white');

      // Set white background when menu is open OR when page has no image background
      const whiteBg = 'rgba(255, 255, 255, 1)';
      allHeaderElements.forEach((el) => {
        if (el) {
          el.style.setProperty('background-color', whiteBg, 'important');
          el.style.setProperty('background', whiteBg, 'important');
          el.style.setProperty('opacity', '1', 'important');
        }
      });
      
      // Set text/links to black when background is white
      // (child <span>s too — the contrast-mode injected stylesheet targets spans
      // directly with !important, so inherited color from the <a> is not enough)
      headerLinks.forEach((link) => {
        link.style.setProperty('color', '#000000', 'important');
        link.style.setProperty('fill', '#000000', 'important');
        link.querySelectorAll('span').forEach((sp) => {
          sp.style.setProperty('color', '#000000', 'important');
        });
      });
      
      // Set logo and text elements to black
      headerText.forEach((textEl) => {
        textEl.style.setProperty('color', '#000000', 'important');
        textEl.style.setProperty('fill', '#000000', 'important');
      });
      
      // Set search elements to black
      searchElements.forEach((el) => {
        el.style.setProperty('color', '#000000', 'important');
        el.style.setProperty('fill', '#000000', 'important');
        // Also set input text color
        if (el.tagName === 'INPUT' || el.classList.contains('header-search-input')) {
          el.style.setProperty('color', '#000000', 'important');
        }
        // Set icon color - remove invert filters
        const icons = el.querySelectorAll('img, svg, [class*="icon"]');
        icons.forEach((icon) => {
          icon.style.setProperty('filter', 'none', 'important');
        });
      });
      
      // Also target search input and icon directly
      const searchInput = header.querySelector('#header-search-input, .header-search-input');
      if (searchInput) {
        searchInput.style.setProperty('color', '#000000', 'important');
      }
      const searchForm = header.querySelector('.header-search-form');
      if (searchForm) {
        // Ensure search form border stays visible
        searchForm.style.setProperty('border-color', '#d8d8dc', 'important');
        searchForm.style.setProperty('background-color', '#f3f3f5', 'important');
      }
      const searchIcon = header.querySelector('.header-search-icon img, .header-search-icon');
      if (searchIcon) {
        searchIcon.style.setProperty('filter', 'none', 'important');
        const iconImg = searchIcon.tagName === 'IMG' ? searchIcon : searchIcon.querySelector('img');
        if (iconImg) {
          iconImg.style.setProperty('filter', 'none', 'important');
        }
      }
      
      // Set hamburger icon to BLACK when background is WHITE (when menu is open or header is engaged)
      // When background is white, logo is DARK, so hamburger should be BLACK to match
      const hamburgerButton = header.querySelector('.header-menu-toggle button, .js-open-mm, button.js-open-mm');
      if (hamburgerButton) {
        const hamburgerSvg = hamburgerButton.querySelector('svg');
        if (hamburgerSvg) {
          // CRITICAL: Always set to black when background is white (including when mobile menu is open)
          // Mobile menu code also sets it, but we ensure it here too for consistency
          // Set color to black on SVG for currentColor inheritance
          hamburgerSvg.style.setProperty('filter', 'none', 'important');
          hamburgerSvg.style.setProperty('color', '#000000', 'important');
          
          // CRITICAL: Set stroke directly to black
          const hamburgerG = hamburgerSvg.querySelector('g#hamburger');
          if (hamburgerG) {
            hamburgerG.setAttribute('stroke', '#000000');
            hamburgerG.style.setProperty('stroke', '#000000', 'important');
          }
          
          // Set stroke directly on all line elements to black
          const allLines = hamburgerSvg.querySelectorAll('line');
          allLines.forEach((line) => {
            line.setAttribute('stroke', '#000000');
            line.style.setProperty('stroke', '#000000', 'important');
          });
          
          // Also set on all paths and groups to ensure complete coverage
          const allPaths = hamburgerSvg.querySelectorAll('path, g');
          allPaths.forEach((path) => {
            path.style.setProperty('stroke', '#000000', 'important');
            path.style.setProperty('color', '#000000', 'important');
            if (path.tagName === 'g') {
              path.setAttribute('stroke', '#000000');
            }
          });
        } else {
          console.warn('Hamburger SVG not found in button');
        }
      } else {
        console.warn('Hamburger button not found');
      }
      
      // Set placeholder color via style element (can't be set via inline styles)
      styleEl.textContent = `
        header[data-site-header] .header-search-input::placeholder {
          color: #6d6d75 !important;
        }
        header[data-site-header] .header-search-icon img {
          filter: none !important;
        }
        header[data-site-header] .header-bag-icon img {
          filter: none !important;
        }
        header[data-site-header] .header-bag-text {
          color: #000000 !important;
        }
        header[data-site-header] .header-search-form {
          border-color: #d8d8dc !important;
          background-color: #f3f3f5 !important;
        }
        header[data-site-header] .header-search-form:focus-within {
          border-color: #000000 !important;
          background-color: #ffffff !important;
        }
        header[data-site-header] .header-bag-button {
          border-color: #d8d8dc !important;
          background-color: #ffffff !important;
        }
        header[data-site-header] .header-bag-button:hover,
        header[data-site-header] .header-bag-button:focus {
          border-color: #000000 !important;
          background-color: #ffffff !important;
        }
        header[data-site-header] .header-bag-count {
          background-color: #000000 !important;
          color: #ffffff !important;
        }
        header[data-site-header] .header-menu-toggle svg,
        header[data-site-header] .js-open-mm svg,
        header[data-site-header] .header-menu-toggle button svg {
          filter: none !important;
          color: #000000 !important;
        }
        header[data-site-header] .header-menu-toggle svg g#hamburger,
        header[data-site-header] .js-open-mm svg g#hamburger,
        header[data-site-header] .header-menu-toggle button svg g#hamburger {
          stroke: currentColor !important;
        }
        header[data-site-header] .js-open-mm svg line,
        header[data-site-header] .header-menu-toggle svg line {
          stroke: currentColor !important;
        }
      `;
      
      // Set bag elements to black
      bagElements.forEach((el) => {
        el.style.setProperty('color', '#000000', 'important');
        el.style.setProperty('fill', '#000000', 'important');
        // Set icon color - remove invert filters
        const icons = el.querySelectorAll('img, svg, [class*="icon"]');
        icons.forEach((icon) => {
          icon.style.setProperty('filter', 'none', 'important');
        });
      });
      
      // Also target bag icon directly
      const bagIcon = header.querySelector('.header-bag-icon img, .header-bag-icon');
      if (bagIcon) {
        bagIcon.style.setProperty('filter', 'none', 'important');
        const iconImg = bagIcon.tagName === 'IMG' ? bagIcon : bagIcon.querySelector('img');
        if (iconImg) {
          iconImg.style.setProperty('filter', 'none', 'important');
        }
      }
      const bagText = header.querySelector('.header-bag-text');
      if (bagText) {
        bagText.style.setProperty('color', '#000000', 'important');
      }
      const bagCount = header.querySelector('.header-bag-count');
      if (bagCount) {
        // Ensure bag count badge stays black background with white text
        bagCount.style.setProperty('background-color', '#000000', 'important');
        bagCount.style.setProperty('color', '#ffffff', 'important');
      }
      const bagButton = header.querySelector('.header-bag-button');
      if (bagButton) {
        // Ensure bag button border stays visible with proper colors
        // When header is white, bag button should be white or transparent
        bagButton.style.setProperty('border-color', '#d8d8dc', 'important');
        bagButton.style.setProperty('background-color', '#ffffff', 'important');
      }
      
      // Also set logo images - switch to dark logo if available
      const logoImages = header.querySelectorAll('img[data-header-logo], .header-logo img, [class*="logo"] img');
      logoImages.forEach((img) => {
        // Remove any filters that might make it white
        img.style.setProperty('filter', 'none', 'important');
        
        // Switch to dark logo if data attributes are available
        const darkLogo = img.getAttribute('data-logo-default');
        const whiteLogo = img.getAttribute('data-logo-bleed');
        if (darkLogo) {
          // Always switch to dark logo when background is white
          // Check if current src is the white logo or if it's not the dark logo
          const currentSrc = img.src || img.getAttribute('src');
          if (currentSrc !== darkLogo) {
            img.src = darkLogo;
          }
        }
      });
      
      // VAULT DARK MODE: on vault templates (body.vault-dark-header) the engaged header is
      // BLACK with WHITE logo/text instead of white with black text. Applied as overrides
      // AFTER the standard engaged styling above (later inline !important writes win).
      // Skipped when the mobile menu drawer is open (white drawer needs the standard white
      // header + black hamburger). High-contrast mode KEEPS the black header — white on
      // black is already maximum contrast, so the vault look stays.
      if (document.body.classList.contains('vault-dark-header') && !mobileMenuOpen) {
        header.setAttribute('data-header-bg', 'black');
        
        const vaultBg = 'rgba(0, 0, 0, 1)';
        allHeaderElements.forEach((el) => {
          if (el) {
            el.style.setProperty('background-color', vaultBg, 'important');
            el.style.setProperty('background', vaultBg, 'important');
          }
        });
        
        headerLinks.forEach((link) => {
          link.style.setProperty('color', '#ffffff', 'important');
          link.style.setProperty('fill', '#ffffff', 'important');
          // Child <span>s must be painted white directly: the contrast-mode
          // injected stylesheet hits spans with a universal black !important
          // rule, which overrides color inherited from the <a>.
          link.querySelectorAll('span').forEach((sp) => {
            sp.style.setProperty('color', '#ffffff', 'important');
          });
        });
        headerText.forEach((textEl) => {
          textEl.style.setProperty('color', '#ffffff', 'important');
          textEl.style.setProperty('fill', '#ffffff', 'important');
        });
        
        // Search: white text, dark field, icon inverted to white
        searchElements.forEach((el) => {
          el.style.setProperty('color', '#ffffff', 'important');
          el.style.setProperty('fill', '#ffffff', 'important');
          el.querySelectorAll('img, svg, [class*="icon"]').forEach((icon) => {
            icon.style.setProperty('filter', 'invert(1)', 'important');
          });
        });
        const vaultSearchInput = header.querySelector('#header-search-input, .header-search-input');
        if (vaultSearchInput) {
          vaultSearchInput.style.setProperty('color', '#ffffff', 'important');
        }
        const vaultSearchForm = header.querySelector('.header-search-form');
        if (vaultSearchForm) {
          vaultSearchForm.style.setProperty('border-color', 'rgba(255, 255, 255, 0.4)', 'important');
          vaultSearchForm.style.setProperty('background-color', 'rgba(255, 255, 255, 0.12)', 'important');
        }
        const vaultSearchIcon = header.querySelector('.header-search-icon img, .header-search-icon');
        if (vaultSearchIcon) {
          vaultSearchIcon.style.setProperty('filter', 'invert(1)', 'important');
          const vsIconImg = vaultSearchIcon.tagName === 'IMG' ? vaultSearchIcon : vaultSearchIcon.querySelector('img');
          if (vsIconImg) {
            vsIconImg.style.setProperty('filter', 'invert(1)', 'important');
          }
        }
        
        // Bag: white text/icon, dark button, white count badge
        bagElements.forEach((el) => {
          el.style.setProperty('color', '#ffffff', 'important');
          el.style.setProperty('fill', '#ffffff', 'important');
          el.querySelectorAll('img, svg, [class*="icon"]').forEach((icon) => {
            icon.style.setProperty('filter', 'invert(1)', 'important');
          });
        });
        const vaultBagIcon = header.querySelector('.header-bag-icon img, .header-bag-icon');
        if (vaultBagIcon) {
          vaultBagIcon.style.setProperty('filter', 'invert(1)', 'important');
          const vbIconImg = vaultBagIcon.tagName === 'IMG' ? vaultBagIcon : vaultBagIcon.querySelector('img');
          if (vbIconImg) {
            vbIconImg.style.setProperty('filter', 'invert(1)', 'important');
          }
        }
        const vaultBagText = header.querySelector('.header-bag-text');
        if (vaultBagText) {
          vaultBagText.style.setProperty('color', '#ffffff', 'important');
        }
        const vaultBagCount = header.querySelector('.header-bag-count');
        if (vaultBagCount) {
          vaultBagCount.style.setProperty('background-color', '#ffffff', 'important');
          vaultBagCount.style.setProperty('color', '#000000', 'important');
        }
        const vaultBagButton = header.querySelector('.header-bag-button');
        if (vaultBagButton) {
          vaultBagButton.style.setProperty('border-color', 'rgba(255, 255, 255, 0.4)', 'important');
          vaultBagButton.style.setProperty('background-color', 'rgba(255, 255, 255, 0.12)', 'important');
        }
        
        // Hamburger: white strokes on black background
        const vaultHamburgerButton = header.querySelector('.header-menu-toggle button, .js-open-mm, button.js-open-mm');
        if (vaultHamburgerButton) {
          const vaultHamburgerSvg = vaultHamburgerButton.querySelector('svg');
          if (vaultHamburgerSvg) {
            vaultHamburgerSvg.style.setProperty('filter', 'none', 'important');
            vaultHamburgerSvg.style.setProperty('color', '#ffffff', 'important');
            const vaultHamburgerG = vaultHamburgerSvg.querySelector('g#hamburger');
            if (vaultHamburgerG) {
              vaultHamburgerG.setAttribute('stroke', '#ffffff');
              vaultHamburgerG.style.setProperty('stroke', '#ffffff', 'important');
            }
            vaultHamburgerSvg.querySelectorAll('line').forEach((line) => {
              line.setAttribute('stroke', '#ffffff');
              line.style.setProperty('stroke', '#ffffff', 'important');
            });
            vaultHamburgerSvg.querySelectorAll('path, g').forEach((path) => {
              path.style.setProperty('stroke', '#ffffff', 'important');
              path.style.setProperty('color', '#ffffff', 'important');
              if (path.tagName === 'g') {
                path.setAttribute('stroke', '#ffffff');
              }
            });
          }
        }
        
        // Logo: keep the WHITE (bleed) logo on the black engaged header
        logoImages.forEach((img) => {
          const whiteLogo = img.getAttribute('data-logo-bleed');
          if (whiteLogo) {
            const currentSrc = img.src || img.getAttribute('src');
            if (currentSrc !== whiteLogo) {
              img.src = whiteLogo;
            }
          }
        });
        
        // Replace the injected style rules with dark-header equivalents
        styleEl.textContent = `
          header[data-site-header] .header-search-input::placeholder {
            color: rgba(255, 255, 255, 0.65) !important;
          }
          header[data-site-header] .header-search-icon img {
            filter: invert(1) !important;
          }
          header[data-site-header] .header-bag-icon img {
            filter: invert(1) !important;
          }
          header[data-site-header] .header-bag-text {
            color: #ffffff !important;
          }
          header[data-site-header] .header-search-form {
            border-color: rgba(255, 255, 255, 0.4) !important;
            background-color: rgba(255, 255, 255, 0.12) !important;
          }
          header[data-site-header] .header-search-form:focus-within {
            border-color: #ffffff !important;
            background-color: rgba(255, 255, 255, 0.2) !important;
          }
          header[data-site-header] .header-bag-button {
            border-color: rgba(255, 255, 255, 0.4) !important;
            background-color: rgba(255, 255, 255, 0.12) !important;
          }
          header[data-site-header] .header-bag-button:hover,
          header[data-site-header] .header-bag-button:focus {
            border-color: #ffffff !important;
            background-color: rgba(255, 255, 255, 0.2) !important;
          }
          header[data-site-header] .header-bag-count {
            background-color: #ffffff !important;
            color: #000000 !important;
          }
          header[data-site-header] .header-menu-toggle svg,
          header[data-site-header] .js-open-mm svg,
          header[data-site-header] .header-menu-toggle button svg {
            filter: none !important;
            color: #ffffff !important;
          }
          header[data-site-header] .header-menu-toggle svg g#hamburger,
          header[data-site-header] .js-open-mm svg g#hamburger,
          header[data-site-header] .header-menu-toggle button svg g#hamburger {
            stroke: currentColor !important;
          }
          header[data-site-header] .js-open-mm svg line,
          header[data-site-header] .header-menu-toggle svg line {
            stroke: currentColor !important;
          }
        `;
      }
      
    } else {
      header.setAttribute('data-header-bg', 'transparent');

      // Set transparent when menu is closed AND page has image background
      const transparentBg = 'transparent';
      allHeaderElements.forEach((el) => {
        if (el) {
          el.style.setProperty('background-color', transparentBg, 'important');
          el.style.setProperty('background', transparentBg, 'important');
          el.style.setProperty('opacity', '1', 'important');
        }
      });
      
      // Reset text/links to white (or original color) when background is transparent
      headerLinks.forEach((link) => {
        link.style.removeProperty('color');
        link.style.removeProperty('fill');
        link.querySelectorAll('span').forEach((sp) => {
          sp.style.removeProperty('color');
        });
      });
      
      // Reset logo and text elements
      headerText.forEach((textEl) => {
        textEl.style.removeProperty('color');
        textEl.style.removeProperty('fill');
      });
      
      // Reset search elements
      searchElements.forEach((el) => {
        el.style.removeProperty('color');
        el.style.removeProperty('fill');
        if (el.tagName === 'INPUT' || el.classList.contains('header-search-input')) {
          el.style.removeProperty('color');
        }
        const icons = el.querySelectorAll('img, svg, [class*="icon"]');
        icons.forEach((icon) => {
          icon.style.removeProperty('filter');
        });
      });
      
      // CRITICAL: Reset search form background and border when reverting to transparent (mobile fix)
      const searchForm = header.querySelector('.header-search-form, .header-search-form-mobile');
      if (searchForm) {
        searchForm.style.removeProperty('background-color');
        searchForm.style.removeProperty('border-color');
        searchForm.style.removeProperty('background');
        searchForm.style.removeProperty('border');
      }
      
      // Also reset mobile search form if it exists (separate from desktop form)
      const mobileSearchForm = header.querySelector('.header-search-form-mobile');
      if (mobileSearchForm && mobileSearchForm !== searchForm) {
        mobileSearchForm.style.removeProperty('background-color');
        mobileSearchForm.style.removeProperty('border-color');
        mobileSearchForm.style.removeProperty('background');
        mobileSearchForm.style.removeProperty('border');
      }
      
      // Reset bag elements
      bagElements.forEach((el) => {
        el.style.removeProperty('color');
        el.style.removeProperty('fill');
        const icons = el.querySelectorAll('img, svg, [class*="icon"]');
        icons.forEach((icon) => {
          icon.style.removeProperty('filter');
        });
      });
      
      // Reset hamburger — CSS defaults (white + hero-bleed invert) handle transparent header
      const hamburgerButton = header.querySelector('.header-menu-toggle button, .js-open-mm, button.js-open-mm');
      if (hamburgerButton) {
        hamburgerButton.style.removeProperty('color');
        const hamburgerSvg = hamburgerButton.querySelector('svg');
        if (hamburgerSvg) {
          hamburgerSvg.style.removeProperty('color');
          hamburgerSvg.style.removeProperty('filter');
          hamburgerSvg.style.removeProperty('stroke');
          hamburgerSvg.removeAttribute('stroke');
          hamburgerSvg.removeAttribute('color');
          const hamburgerG = hamburgerSvg.querySelector('g#hamburger');
          if (hamburgerG) {
            hamburgerG.removeAttribute('stroke');
            hamburgerG.style.removeProperty('stroke');
            hamburgerG.style.removeProperty('color');
          }
          hamburgerSvg.querySelectorAll('line, path, g').forEach((el) => {
            el.style.removeProperty('stroke');
            el.style.removeProperty('color');
            if (el.tagName === 'g' || el.tagName === 'line') {
              el.removeAttribute('stroke');
            }
          });
        }
      }
      
      // Clear style element - CSS default in header.liquid will handle white color
      // No need for style element override when background is transparent
      if (styleEl) {
        styleEl.textContent = '';
      }
      
      // Explicitly reset bag button styles when menu closes
      const bagButton = header.querySelector('.header-bag-button');
      if (bagButton) {
        bagButton.style.removeProperty('border-color');
        bagButton.style.removeProperty('background-color');
        bagButton.style.removeProperty('color');
      }
      const bagIcon = header.querySelector('.header-bag-icon img, .header-bag-icon');
      if (bagIcon) {
        bagIcon.style.removeProperty('filter');
        const iconImg = bagIcon.tagName === 'IMG' ? bagIcon : bagIcon.querySelector('img');
        if (iconImg) {
          iconImg.style.removeProperty('filter');
        }
      }
      const bagText = header.querySelector('.header-bag-text');
      if (bagText) {
        bagText.style.removeProperty('color');
      }
      const bagCount = header.querySelector('.header-bag-count');
      if (bagCount) {
        bagCount.style.removeProperty('background-color');
        bagCount.style.removeProperty('color');
      }
      
      // Reset logo images - switch back to white logo if available
      const logoImages = header.querySelectorAll('img[data-header-logo], .header-logo img, [class*="logo"] img');
      logoImages.forEach((img) => {
        img.style.removeProperty('filter');
        
        // Switch back to white logo if data attributes are available
        const whiteLogo = img.getAttribute('data-logo-bleed');
        const darkLogo = img.getAttribute('data-logo-default');
        if (whiteLogo) {
          // Switch back to white logo when background is transparent
          // Check if current src is the dark logo
          const currentSrc = img.src || img.getAttribute('src');
          if (currentSrc === darkLogo || currentSrc.includes('Lotto-Logo.png')) {
            img.src = whiteLogo;
          }
        }
      });
    }
  };
  
  // Expose setHeaderBackground globally so contrast mode can access it
  window.setHeaderBackground = setHeaderBackground;
  
  // Initialize header on page load - will check for image background and set appropriate state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setHeaderBackground(false));
  } else {
    setHeaderBackground(false);
  }

  const closeItem = (item) => {
    const trigger = item.querySelector('[data-megamenu-trigger]');
    const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!trigger || !panel) {
      console.warn('closeItem: Missing trigger or panel', { trigger: !!trigger, panel: !!panel });
      return;
    }

    console.log('closeItem: Closing menu for', panelId);
    
    item.classList.remove('is-open');
    item.classList.remove('open');
    // CRITICAL: Don't remove panel-has-focus here - it should stay until another item is selected
    // or focus leaves the header entirely. The class will be removed in those specific handlers.
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.classList.add('hidden');
    
    // CRITICAL: Force hide with inline styles to override any CSS
    panel.style.cssText = 'position: fixed !important; display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important;';
    
    panel.setAttribute('tabindex', '-1');
    restorePanelFocusableTabOrder(panel);
    
    console.log('closeItem: Panel hidden', { 
      hasHiddenClass: panel.classList.contains('hidden'),
      ariaHidden: panel.getAttribute('aria-hidden'),
      computedDisplay: window.getComputedStyle(panel).display
    });
    
    // Check if any other menu is still open
    const anyMenuOpen = menuItems.some(i => {
      const t = i.querySelector('[data-megamenu-trigger]');
      return t && t.getAttribute('aria-expanded') === 'true';
    });
    
    // Only set header to transparent if no menus are open
    if (!anyMenuOpen) {
      setHeaderBackground(false);
    }
    
    // Panel stays in body - don't move it back
    // It will be moved to body again when opened next time
  };

  const openItemFn = (item, focusFirstEl = false) => {
    if (!isDesktop()) return;
    if (openItem && openItem !== item) {
      closeItem(openItem);
    }
    const trigger = item.querySelector('[data-megamenu-trigger]');
    const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!trigger || !panel) return;

    item.classList.add('is-open');
    item.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    
    // Set header background to white when menu opens
    setHeaderBackground(true);
    
    // CRITICAL: Verify panel is in body - it should have been moved during initialization
    // If somehow still in header, move it now
    if (panel.parentElement !== document.body) {
      console.warn('openItemFn: Panel NOT in body! Moving now...', 'Current parent:', panel.parentElement?.tagName);
      // Store original parent if not already stored
      if (!panel.dataset.originalParent) {
        panel.dataset.originalParent = panel.parentElement.tagName + (panel.parentElement.className ? '.' + panel.parentElement.className.split(' ')[0] : '');
      }
      // Force move to body
      document.body.appendChild(panel);
      console.warn('openItemFn: Moved panel to body');
    }
    
    // CRITICAL: Verify it's actually in body now
    if (panel.parentElement !== document.body) {
      console.error('openItemFn: CRITICAL ERROR - Panel still not in body after move!');
      // Last resort: remove and re-append
      const panelClone = panel.cloneNode(true);
      panel.parentElement.removeChild(panel);
      document.body.appendChild(panelClone);
      // Update reference
      const newPanel = document.getElementById(panelId);
      if (newPanel) {
        console.error('openItemFn: Recreated panel in body');
      }
    }
    
    console.log('openItemFn: Panel verified in body - parent:', panel.parentElement?.tagName, 'is body?', panel.parentElement === document.body);
    
    // CRITICAL: Remove ALL Tailwind classes that might position it relative to parent
    // Remove absolute, relative, top-100, left-0, right-0, and any positioning classes
    const classesToRemove = ['absolute', 'relative', 'top-100', 'left-0', 'right-0', 'hidden'];
    classesToRemove.forEach(cls => {
      if (panel.classList.contains(cls)) {
        panel.classList.remove(cls);
      }
    });
    
    // Remove hidden class after moving to body
    panel.classList.remove('hidden');
    
    panel.setAttribute('tabindex', '-1');
    restorePanelFocusableTabOrder(panel);
    
    // CRITICAL: Calculate header bottom and set positioning
    // The flyout is completely independent - only needs to know where header ends
    const header = document.querySelector('header[data-site-header]') || 
                   document.querySelector('header') ||
                   document.querySelector('.header-container') ||
                   document.querySelector('.header-main');
    if (header) {
      const headerRect = header.getBoundingClientRect();
      const headerBottom = Math.floor(headerRect.bottom);
      // Set CSS variable so CSS can use it for top positioning
      document.documentElement.style.setProperty('--header-height', headerBottom + 'px');
      
      // CRITICAL: Clear ALL existing inline styles first, then set new ones
      // This ensures no conflicting styles from CSS or previous states
      panel.style.cssText = '';
      
      // CRITICAL: Set ALL positioning properties - panel is now in body, so fixed positioning works
      // Use cssText for atomic update to prevent any intermediate states
      // CRITICAL: Use 100vw (viewport width) NOT 100% (which would be body width)
      // VAULT DARK: on vault templates the flyout panel is black (matches black engaged
      // header). Inline !important is required here because this cssText write would
      // otherwise beat the vault-dark CSS rules in header.liquid. Applies in high
      // contrast mode too — white text on black is already maximum contrast.
      const panelBg = document.body.classList.contains('vault-dark-header') ? '#000000' : 'white';
      const viewportWidth = window.innerWidth;
      panel.style.cssText = 'position: fixed !important; top: ' + headerBottom + 'px !important; left: 0 !important; right: 0 !important; width: ' + viewportWidth + 'px !important; max-width: ' + viewportWidth + 'px !important; min-width: ' + viewportWidth + 'px !important; margin: 0 !important; margin-left: 0 !important; margin-right: 0 !important; margin-top: 0 !important; margin-bottom: 0 !important; padding: 0 !important; transform: none !important; translate: none !important; z-index: 9999 !important; display: block !important; visibility: visible !important; opacity: 1 !important; background: ' + panelBg + ' !important; border-top: none !important; overflow: visible !important;';
      
      // Verify positioning after a frame
      requestAnimationFrame(() => {
        const rect = panel.getBoundingClientRect();
        const computed = window.getComputedStyle(panel);
        console.log('Panel positioning verification:');
        console.log('  Parent:', panel.parentElement?.tagName, 'is body?', panel.parentElement === document.body);
        console.log('  Position:', computed.position);
        console.log('  Left:', computed.left, 'Actual left:', rect.left);
        console.log('  Width:', computed.width, 'Actual width:', rect.width, 'Viewport width:', window.innerWidth);
        console.log('  Top:', computed.top, 'Actual top:', rect.top, 'Header bottom:', headerBottom);
        
        // If not positioned correctly, force correction
        const expectedWidth = window.innerWidth; // Use viewport width, not body width
        if (Math.abs(rect.left) > 1 || Math.abs(rect.width - expectedWidth) > 1) {
          console.warn('Panel not full viewport width! Forcing correction...');
          console.warn('  Expected width:', expectedWidth, 'Actual width:', rect.width);
          console.warn('  Expected left: 0, Actual left:', rect.left);
          console.warn('  Panel parent:', panel.parentElement?.tagName, 'is body?', panel.parentElement === document.body);
          console.warn('  Computed position:', computed.position);
          
          // Ensure it's in body
          if (panel.parentElement !== document.body) {
            console.warn('  Moving panel to body...');
            document.body.appendChild(panel);
          }
          
          // Force correct positioning with viewport width (keep vault dark panel bg)
          panel.style.cssText = 'position: fixed !important; top: ' + headerBottom + 'px !important; left: 0 !important; right: 0 !important; width: ' + expectedWidth + 'px !important; max-width: ' + expectedWidth + 'px !important; min-width: ' + expectedWidth + 'px !important; margin: 0 !important; margin-left: 0 !important; margin-right: 0 !important; margin-top: 0 !important; margin-bottom: 0 !important; padding: 0 !important; transform: none !important; translate: none !important; z-index: 9999 !important; display: block !important; visibility: visible !important; opacity: 1 !important; background: ' + panelBg + ' !important; border-top: none !important; overflow: visible !important;';
          
          // Verify again
          requestAnimationFrame(() => {
            const newRect = panel.getBoundingClientRect();
            console.warn('  After correction - width:', newRect.width, 'left:', newRect.left);
            if (Math.abs(newRect.left) > 1 || Math.abs(newRect.width - expectedWidth) > 1) {
              console.error('  STILL not correct after correction!');
            }
          });
        }
      });
    }
    
    openItem = item;
    
    // CRITICAL: Add panel-has-focus class when panel opens
    // This ensures the top-level menu item shows its border indicator
    // The class will stay until another menu item is selected or focus moves elsewhere
    item.classList.add('panel-has-focus');

    const triggerTitle = (trigger.querySelector('span:not(.sr-only)') || trigger).textContent.trim();
    announceNavMenu(triggerTitle + ' submenu opened');

    if (focusFirstEl) {
      const focusable = getPanelFocusableElements(panel);
      if (focusable.length > 0) {
        focusable[0].focus();
      } else {
        panel.setAttribute('tabindex', '-1');
        panel.focus();
      }
    }
  };

  const handlePointerEnter = (item) => {
    if (!isDesktop()) return;
    
    // CRITICAL: Remove panel-has-focus from all other menu items
    // This ensures only one menu item shows the border indicator at a time
    const allMenuItems = Array.from(document.querySelectorAll('[data-megamenu-item]'));
    allMenuItems.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.classList.remove('panel-has-focus');
      }
    });
    
    openItemFn(item, false);
    // CRITICAL: Add panel-has-focus class when menu item is selected
    // This ensures the border indicator is visible - it will stay until another item is selected
    item.classList.add('panel-has-focus');
    // Set header background to white when hovering over menu item
    setHeaderBackground(true);
  };

  // Track mouse position to prevent premature closing
  let mouseLeaveTimeout = null;
  let isMouseOverPanel = false;
  let isMouseOverItem = false;
  
  const handlePointerLeave = (item, event) => {
    if (!isDesktop()) return;
    
    isMouseOverItem = false;
    
    const trigger = item.querySelector('[data-megamenu-trigger]');
    const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
    const panel = panelId ? document.getElementById(panelId) : null;
    
    // CRITICAL: Immediately set header white when leaving item - we might be moving to panel
    setHeaderBackground(true);
    
    // Check if mouse is moving to the panel
    if (panel && event && event.relatedTarget) {
      // If moving to panel or panel contains the related target, don't close
      if (panel === event.relatedTarget || panel.contains(event.relatedTarget)) {
        // Keep header white and don't close
        setHeaderBackground(true);
        return;
      }
    }
    
    // Add a delay to allow mouse to move to panel
    // Use a longer delay to account for the gap between item and panel
    if (mouseLeaveTimeout) {
      clearTimeout(mouseLeaveTimeout);
    }
    
    mouseLeaveTimeout = setTimeout(() => {
      // Check if mouse is now over the panel or item
      if (isMouseOverPanel || isMouseOverItem) {
        // Keep header white
        setHeaderBackground(true);
        return;
      }
      
      // CRITICAL: Use current mouse position to check if it's over panel or item
      // This is more reliable than using event.clientX/Y which might be stale
      if (panel && event) {
        // Get current mouse position from the event
        const mouseX = event.clientX;
        const mouseY = event.clientY;
        
        // Check what element is under the mouse now
        const elementUnderMouse = document.elementFromPoint(mouseX, mouseY);
        if (elementUnderMouse) {
          // Check if it's within panel or item
          if (panel.contains(elementUnderMouse) || item.contains(elementUnderMouse)) {
            // Mouse is over panel or item, keep header white and don't close
            setHeaderBackground(true);
            return;
          }
        }
      }
      
      // Mouse has truly left both item and panel - close menu and set header transparent
      // CRITICAL: Set header transparent BEFORE closing to prevent white flash
      setHeaderBackground(false);
      closeItem(item);
      if (openItem === item) {
        openItem = null;
      }
      mouseLeaveTimeout = null;
    }, 300); // Increased delay to allow mouse movement to panel (including gap)
  };
  
  const handlePanelMouseLeave = (item, event) => {
    if (!isDesktop()) return;
    
    isMouseOverPanel = false;
    
    const trigger = item.querySelector('[data-megamenu-trigger]');
    
    // Check if mouse is moving back to the menu item
    if (event && event.relatedTarget) {
      // If moving to menu item or item contains the related target, don't close
      if (item === event.relatedTarget || item.contains(event.relatedTarget)) {
        return;
      }
    }
    
    // Add a small delay to allow mouse to move back to item
    if (mouseLeaveTimeout) {
      clearTimeout(mouseLeaveTimeout);
    }
    
    mouseLeaveTimeout = setTimeout(() => {
      // Check if mouse is now over the panel or item
      if (isMouseOverPanel || isMouseOverItem) {
        return;
      }
      
      // Double-check: if mouse is now over the item, don't close
      if (event) {
        const elementUnderMouse = document.elementFromPoint(event.clientX, event.clientY);
        if (elementUnderMouse && (item === elementUnderMouse || item.contains(elementUnderMouse))) {
          return;
        }
      }
      
      // Mouse truly left - set header transparent and close
      // CRITICAL: Set header transparent BEFORE closing to prevent white flash
      setHeaderBackground(false);
      closeItem(item);
      if (openItem === item) {
        openItem = null;
      }
      mouseLeaveTimeout = null;
    }, 150); // Small delay to allow mouse movement back to item
  };

  const handleTriggerKeydown = (event, item) => {
    const trigger = event.currentTarget;
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    // CRITICAL: Handle arrow keys on trigger when panel is open
    // This allows arrow keys to navigate within the panel even when focus is on trigger
    if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      if (isExpanded && panel) {
        // Panel is open - handle navigation in panel
        event.preventDefault();
        event.stopPropagation();
        // Ensure panel-has-focus class is set
        item.classList.add('panel-has-focus');
        // Handle navigation - handlePanelKeydown will move focus to first element if needed
        handlePanelKeydown(event, item, trigger);
        return;
      } else if (!isExpanded && event.key === 'ArrowDown') {
        // Panel is closed - open it and focus first element
        event.preventDefault();
        event.stopPropagation();
        openItemFn(item, true);
        return;
      }
    }
    
    switch (event.key) {
      case 'ArrowDown':
      case 'Down':
        event.preventDefault();
        openItemFn(item, true);
        break;
      case 'Enter':
      case ' ':
      case 'Space':
      case 'Spacebar':
        if (isDesktop()) {
          const hasSubmenu = trigger.getAttribute('data-has-submenu') === 'true';
          if (hasSubmenu) {
            event.preventDefault();
            if (!isExpanded) {
              openItemFn(item, true);
            } else if (trigger.href) {
              const href = trigger.href.trim();
              const isEmptyLink = href === '#' || href.endsWith('#');
              if (!isEmptyLink) {
                window.location.href = href;
              }
            }
            return;
          }
          event.preventDefault();
          // Not a real link - toggle the menu
          if (isExpanded) {
            closeItem(item);
            openItem = null;
          } else {
            openItemFn(item, true);
          }
        }
        break;
      case 'Escape':
        event.preventDefault();
        closeItem(item);
        announceNavMenu('Submenu closed');
        trigger.focus();
        if (openItem === item) {
          openItem = null;
        }
        break;
      case 'Tab':
        if (isExpanded && panel) {
          if (event.shiftKey) {
            closeItem(item);
            if (openItem === item) {
              openItem = null;
            }
          } else {
            const focusable = getPanelFocusableElements(panel);
            if (focusable.length) {
              event.preventDefault();
              focusable[0].focus();
            }
          }
        }
        break;
      default:
        break;
    }
  };

  // ADA-compliant keyboard navigation for flyout menu
  const handlePanelKeydown = (event, item, trigger) => {
    // Panel is in body, not in item - get it via trigger's aria-controls
    const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
    const panel = panelId ? document.getElementById(panelId) : null;
    
    if (!panel) return;
    
    // CRITICAL: Allow navigation even if focus is on trigger
    // This enables arrow keys to work when focus is on the trigger
    const activeElement = document.activeElement;
    const isFocusInPanel = panel.contains(activeElement);
    const isFocusOnTrigger = activeElement === trigger;
    const isPanelOpen = trigger.getAttribute('aria-expanded') === 'true';
    
    // Only handle if focus is within the panel OR on the trigger (when panel is open)
    if (!isFocusInPanel && !(isFocusOnTrigger && isPanelOpen)) return;
    
    // If focus is on trigger and panel is open, focus first element in panel first
    if (isFocusOnTrigger && isPanelOpen) {
      const focusable = Array.from(panel.querySelectorAll(focusableSelector)).filter((el) => {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        return (
          (rect.width > 0 || rect.height > 0) &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          style.opacity !== '0'
        );
      });
      if (focusable.length > 0) {
        focusable[0].focus();
        // After focusing, the activeElement will be in the panel, so continue with navigation
        // But we need to wait a frame for focus to move
        requestAnimationFrame(() => {
          // Now focus is in panel, handle the navigation
          handlePanelKeydown(event, item, trigger);
        });
        return;
      }
    }
    
    // Get all focusable elements in the panel - including deeply nested ones
    const getFocusableElements = () => {
      // CRITICAL: Use a comprehensive selector that includes elements with tabindex="-1"
      // We need to find ALL potentially focusable elements, then filter them
      const comprehensiveSelector = 'a[href], area[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';
      
      // Get ALL elements that could be focusable, including those with tabindex="-1"
      const allElements = Array.from(panel.querySelectorAll(comprehensiveSelector));
      
      return allElements.filter((el) => {
        // Skip if element is the panel itself
        if (el === panel) return false;
        
        // Check if element is actually visible and focusable
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        
        // Check if element or any parent has display:none or visibility:hidden
        let parent = el;
        let isParentHidden = false;
        while (parent && parent !== panel && parent !== document.body) {
          const parentStyle = window.getComputedStyle(parent);
          if (parentStyle.display === 'none' || 
              parentStyle.visibility === 'hidden' ||
              parent.classList.contains('hidden') ||
              parent.hasAttribute('hidden')) {
            isParentHidden = true;
            break;
          }
          parent = parent.parentElement;
        }
        
        if (isParentHidden) return false;
        
        // Element must have dimensions and be visible
        const isVisible = (
          (rect.width > 0 || rect.height > 0) &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          parseFloat(style.opacity) > 0 &&
          !el.hasAttribute('hidden') &&
          !el.classList.contains('hidden')
        );
        
        if (!isVisible) return false;
        
        // Check if element is naturally focusable or has a tabindex
        const isNaturallyFocusable = el.matches('a[href], button, input, select, textarea');
        const hasTabindex = el.hasAttribute('tabindex');
        const tabindexValue = el.getAttribute('tabindex');
        
        // CRITICAL: Naturally focusable elements can ALWAYS be focused programmatically
        // even with tabindex="-1" - this is key for keyboard navigation
        // Elements with tabindex="0" or positive tabindex are always focusable
        // Only skip non-naturally-focusable elements with tabindex="-1"
        if (isNaturallyFocusable) {
          // Naturally focusable - always allow (even with tabindex="-1")
          return true;
        } else if (hasTabindex) {
          // Has tabindex attribute
          if (tabindexValue === '-1') {
            // Non-naturally-focusable with tabindex="-1" - skip
            return false;
      } else {
            // Has tabindex="0" or positive - allow
            return true;
          }
        } else {
          // No tabindex and not naturally focusable - skip
          return false;
        }
      });
    };
    
    switch (event.key) {
      case 'Escape':
        event.preventDefault();
        event.stopPropagation();
        closeItem(item);
        trigger.focus();
        if (openItem === item) {
          openItem = null;
        }
        break;
        
      case 'ArrowDown':
        event.preventDefault();
        event.stopPropagation();
        const focusableDown = getFocusableElements();
        if (focusableDown.length === 0) return;
        
        const currentElDown = document.activeElement;
        if (!currentElDown) return;
        
        // CRITICAL: If focus is on trigger, move to first element in panel
        if (currentElDown === trigger || (item.contains(currentElDown) && !panel.contains(currentElDown))) {
          // Find first focusable element in panel
          if (focusableDown.length > 0) {
            focusableDown[0].focus();
            return; // Exit early since we've moved focus
          }
        }
        
        const currentRectDown = currentElDown.getBoundingClientRect();
        
        // Group elements by column (similar horizontal position)
        // Elements in the same column will have similar left position
        const getColumnId = (el) => {
          const rect = el.getBoundingClientRect();
          // Round to nearest 50px to group into columns
          return Math.round(rect.left / 50) * 50;
        };
        
        const currentColumnId = getColumnId(currentElDown);
        
        // Find all elements in the current column
        const currentColumnElements = focusableDown.filter(el => {
          const elColumnId = getColumnId(el);
          return elColumnId === currentColumnId;
        });
        
        // Sort current column elements by vertical position (top)
        currentColumnElements.sort((a, b) => {
          const rectA = a.getBoundingClientRect();
          const rectB = b.getBoundingClientRect();
          return rectA.top - rectB.top;
        });
        
        const currentIndexInColumn = currentColumnElements.findIndex(el => el === currentElDown);
        
        // Check if there are more items in the current column
        if (currentIndexInColumn < currentColumnElements.length - 1) {
          // Move to next item in current column
          currentColumnElements[currentIndexInColumn + 1]?.focus();
        } else {
          // Finished current column - find next column
          const allColumns = new Set(focusableDown.map(el => getColumnId(el)));
          const sortedColumns = Array.from(allColumns).sort((a, b) => a - b);
          const currentColumnIndex = sortedColumns.indexOf(currentColumnId);
          
          if (currentColumnIndex < sortedColumns.length - 1) {
            // Move to first item in next column
            const nextColumnId = sortedColumns[currentColumnIndex + 1];
            const nextColumnElements = focusableDown.filter(el => getColumnId(el) === nextColumnId);
            nextColumnElements.sort((a, b) => {
              const rectA = a.getBoundingClientRect();
              const rectB = b.getBoundingClientRect();
              return rectA.top - rectB.top;
            });
            if (nextColumnElements.length > 0) {
              nextColumnElements[0]?.focus();
            }
          } else {
            // Last column - wrap to first element of first column
            const firstColumnId = sortedColumns[0];
            const firstColumnElements = focusableDown.filter(el => getColumnId(el) === firstColumnId);
            firstColumnElements.sort((a, b) => {
              const rectA = a.getBoundingClientRect();
              const rectB = b.getBoundingClientRect();
              return rectA.top - rectB.top;
            });
            if (firstColumnElements.length > 0) {
              firstColumnElements[0]?.focus();
            }
          }
        }
        break;
        
      case 'ArrowUp':
        event.preventDefault();
        event.stopPropagation();
        const focusableUp = getFocusableElements();
        if (focusableUp.length === 0) return;
        
        const currentElUp = document.activeElement;
        if (!currentElUp) return;
        
        // Group elements by column (similar horizontal position) - same as ArrowDown
        const getColumnIdUp = (el) => {
          const rect = el.getBoundingClientRect();
          // Round to nearest 50px to group into columns
          return Math.round(rect.left / 50) * 50;
        };
        
        const currentColumnIdUp = getColumnIdUp(currentElUp);
        
        // Find all elements in the current column
        const currentColumnElementsUp = focusableUp.filter(el => {
          const elColumnId = getColumnIdUp(el);
          return elColumnId === currentColumnIdUp;
        });
        
        // Sort current column elements by vertical position (top) - ascending
        currentColumnElementsUp.sort((a, b) => {
          const rectA = a.getBoundingClientRect();
          const rectB = b.getBoundingClientRect();
          return rectA.top - rectB.top;
        });
        
        const currentIndexInColumnUp = currentColumnElementsUp.findIndex(el => el === currentElUp);
        
        // Check if there are more items above in the current column
        if (currentIndexInColumnUp > 0) {
          // Move to previous item in current column
          currentColumnElementsUp[currentIndexInColumnUp - 1]?.focus();
        } else {
          // Finished current column - find previous column
          const allColumnsUp = new Set(focusableUp.map(el => getColumnIdUp(el)));
          const sortedColumnsUp = Array.from(allColumnsUp).sort((a, b) => a - b);
          const currentColumnIndexUp = sortedColumnsUp.indexOf(currentColumnIdUp);
          
          if (currentColumnIndexUp > 0) {
            // Move to last item in previous column
            const prevColumnIdUp = sortedColumnsUp[currentColumnIndexUp - 1];
            const prevColumnElementsUp = focusableUp.filter(el => getColumnIdUp(el) === prevColumnIdUp);
            prevColumnElementsUp.sort((a, b) => {
              const rectA = a.getBoundingClientRect();
              const rectB = b.getBoundingClientRect();
              return rectA.top - rectB.top;
            });
            if (prevColumnElementsUp.length > 0) {
              prevColumnElementsUp[prevColumnElementsUp.length - 1]?.focus();
            }
          } else {
            // First column - wrap to last element of last column
            const lastColumnIdUp = sortedColumnsUp[sortedColumnsUp.length - 1];
            const lastColumnElementsUp = focusableUp.filter(el => getColumnIdUp(el) === lastColumnIdUp);
            lastColumnElementsUp.sort((a, b) => {
              const rectA = a.getBoundingClientRect();
              const rectB = b.getBoundingClientRect();
              return rectA.top - rectB.top;
            });
            if (lastColumnElementsUp.length > 0) {
              lastColumnElementsUp[lastColumnElementsUp.length - 1]?.focus();
            }
          }
        }
        break;
        
      case 'Home':
      event.preventDefault();
        event.stopPropagation();
        const focusableHome = getFocusableElements();
        focusableHome[0]?.focus();
        break;
        
      case 'End':
        event.preventDefault();
        event.stopPropagation();
        const focusableEnd = getFocusableElements();
        if (focusableEnd.length > 0) {
          focusableEnd[focusableEnd.length - 1].focus();
        }
        break;
        
      case 'ArrowLeft':
      case 'ArrowRight':
        event.preventDefault();
        event.stopPropagation();
        // Navigate horizontally through all levels - find all focusable elements
        const focusableAll = getFocusableElements();
        if (focusableAll.length === 0) return;
        
        const currentElement = document.activeElement;
        if (!currentElement) return;
        
        const currentRectHorizontal = currentElement.getBoundingClientRect();
        const currentTopHorizontal = currentRectHorizontal.top;
        const currentLeftHorizontal = currentRectHorizontal.left;
        
        // Sort all elements by position: first by top (vertical), then by left (horizontal)
        const sortedElements = [...focusableAll].sort((a, b) => {
          const rectA = a.getBoundingClientRect();
          const rectB = b.getBoundingClientRect();
          // Primary sort: vertical position (top)
          if (Math.abs(rectA.top - rectB.top) > 5) {
            return rectA.top - rectB.top;
          }
          // Secondary sort: horizontal position (left)
          return rectA.left - rectB.left;
        });
        
        const currentIndex = sortedElements.findIndex(el => el === currentElement);
        if (currentIndex === -1) return;
        
        if (event.key === 'ArrowLeft') {
          // Move to previous element (left, or up if at start of row)
          if (currentIndex > 0) {
            // Check if previous element is at similar vertical position (same row)
            const prevElement = sortedElements[currentIndex - 1];
            const prevRect = prevElement.getBoundingClientRect();
            
            if (Math.abs(prevRect.top - currentTopHorizontal) < 30) {
              // Same row - move to previous
              prevElement.focus();
            } else {
              // Different row - find the last element in the previous row
              let targetIndex = currentIndex - 1;
              while (targetIndex > 0) {
                const targetRect = sortedElements[targetIndex].getBoundingClientRect();
                const nextRect = sortedElements[targetIndex - 1].getBoundingClientRect();
                if (Math.abs(targetRect.top - nextRect.top) > 30) {
                  // Found the start of previous row
                  break;
                }
                targetIndex--;
              }
              sortedElements[targetIndex]?.focus();
            }
          } else {
            // Wrap to last element
            sortedElements[sortedElements.length - 1]?.focus();
          }
        } else {
          // ArrowRight: Move to next element (right, or down if at end of row)
          if (currentIndex < sortedElements.length - 1) {
            // Check if next element is at similar vertical position (same row)
            const nextElement = sortedElements[currentIndex + 1];
            const nextRect = nextElement.getBoundingClientRect();
            
            if (Math.abs(nextRect.top - currentTopHorizontal) < 30) {
              // Same row - move to next
              nextElement.focus();
            } else {
              // Different row - find the first element in the next row
              let targetIndex = currentIndex + 1;
              while (targetIndex < sortedElements.length - 1) {
                const targetRect = sortedElements[targetIndex].getBoundingClientRect();
                const nextRect = sortedElements[targetIndex + 1].getBoundingClientRect();
                if (Math.abs(targetRect.top - nextRect.top) > 30) {
                  // Found the start of next row
                  break;
                }
                targetIndex++;
              }
              sortedElements[targetIndex]?.focus();
            }
          } else {
            // Wrap to first element
            sortedElements[0]?.focus();
          }
        }
        break;
        
      case 'Enter':
      case ' ':
      case 'Space':
      case 'Spacebar':
        event.preventDefault();
        event.stopPropagation();
        // Select/activate the currently focused element
        const activeEl = document.activeElement;
        if (activeEl) {
          // If it's a link, navigate to it
          if (activeEl.tagName === 'A' && activeEl.href) {
            const href = activeEl.href.trim();
            const isEmptyLink = href === '#' || href === window.location.href || href === window.location.href + '#';
            if (!isEmptyLink) {
              window.location.href = href;
              return;
            }
          }
          // If it's a button, click it
          if (activeEl.tagName === 'BUTTON' || activeEl.type === 'button' || activeEl.type === 'submit') {
            activeEl.click();
            return;
          }
          // For other elements, try to find a clickable parent or trigger a click
          if (activeEl.click) {
            activeEl.click();
      } else {
            // Find a clickable parent (link or button)
            const clickableParent = activeEl.closest('a, button');
            if (clickableParent) {
              clickableParent.click();
            }
          }
        }
        break;
        
      default:
        // Let other keys pass through
        break;
    }
  };

  menuItems.forEach((item) => {
    const trigger = item.querySelector('[data-megamenu-trigger]');
    if (!trigger) return;
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    trigger.addEventListener('mouseenter', () => {
      isMouseOverItem = true;
      handlePointerEnter(item);
    });
    item.addEventListener('mouseenter', () => {
      isMouseOverItem = true;
      // handlePointerEnter will add panel-has-focus and remove from others
      if (mouseLeaveTimeout) {
        clearTimeout(mouseLeaveTimeout);
        mouseLeaveTimeout = null;
      }
    });
    trigger.addEventListener('focus', () => {
      // CRITICAL: Remove panel-has-focus from all other menu items
      const allMenuItems = Array.from(document.querySelectorAll('[data-megamenu-item]'));
      allMenuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('panel-has-focus');
        }
      });
      // Add panel-has-focus to this item - it will stay until another is selected
      item.classList.add('panel-has-focus');
      handlePointerEnter(item);
    });
    item.addEventListener('mouseleave', (event) => handlePointerLeave(item, event));
    
    // Close flyout when tabbing out of menu item
    trigger.addEventListener('focusout', (event) => {
      if (!isDesktop()) return;
      
      // CRITICAL: Check relatedTarget immediately (synchronously) to see if focus is moving to panel
      // This prevents menu from closing on initial load when arrow key moves focus to first item
      if (event.relatedTarget && panel && panel.contains(event.relatedTarget)) {
        // Focus is moving to panel - don't close, ensure panel-has-focus class is present
        // Always add the class when focus moves to panel, regardless of is-open state
        // This maintains the border indicator when navigating from trigger to flyout
        item.classList.add('panel-has-focus');
        return;
      }
      
      // Use requestAnimationFrame to check after focus has moved
      requestAnimationFrame(() => {
        const activeElement = document.activeElement;
        const header = getHeader();
        
        // Check if focus moved to the panel (flyout) - don't close in this case
        // CRITICAL: Panels are in body, not children of item, so check panel separately
        // panel-has-focus class is already set - don't need to add again
        if (panel && panel.contains(activeElement)) {
          // Focus moved to flyout, keep menu open
          return;
        }
        
        // Check if focus moved to another menu item - close this one and remove class
        if (header) {
          const allMenuItems = Array.from(header.querySelectorAll('[data-megamenu-item]'));
          const activeItem = allMenuItems.find(menuItem => 
            menuItem.contains(activeElement) && menuItem !== item
          );
          if (activeItem) {
            // Focus moved to another menu item - remove class from this one
            // The new item will get the class when it receives focus
            item.classList.remove('panel-has-focus');
            setHeaderBackground(false);
            closeItem(item);
            if (openItem === item) {
              openItem = null;
            }
            return;
          }
        }
        
        // CRITICAL: Check if focus is still within the item OR the panel
        // Panels are moved to body, so they're not children of item - need to check both
        // If still in item or panel, keep the class - don't remove it
        if (item.contains(activeElement) || (panel && panel.contains(activeElement))) {
          // Still in item or panel - keep panel-has-focus class
          return;
        }
        
        // Check if focus is still within the header (but not in any menu item or panel)
        // This means focus moved to search, bag, logo, etc. - close the flyout but keep class
        if (header && header.contains(activeElement)) {
          // Focus is in header but not in menu item or panel - close flyout
          // Keep panel-has-focus class - it will be removed when another item is selected
          setHeaderBackground(false);
          closeItem(item);
          if (openItem === item) {
            openItem = null;
          }
          return;
        }
        
        // Focus has left the header entirely - close flyout and remove class
        item.classList.remove('panel-has-focus');
        setHeaderBackground(false);
        closeItem(item);
        if (openItem === item) {
          openItem = null;
        }
      });
    });
    
    // CRITICAL: Also listen for mouseleave on the panel (since it's in body, not in item)
    panel.addEventListener('mouseenter', () => {
      isMouseOverPanel = true;
      // Keep header white when mouse enters panel
      // panel-has-focus class is already set when item was selected - don't need to add again
      setHeaderBackground(true);
      if (mouseLeaveTimeout) {
        clearTimeout(mouseLeaveTimeout);
        mouseLeaveTimeout = null;
      }
    });
    panel.addEventListener('mouseleave', (event) => {
      isMouseOverPanel = false;
      
      // CRITICAL: Check if mouse is moving back to the menu item
      if (event && event.relatedTarget) {
        if (item === event.relatedTarget || item.contains(event.relatedTarget)) {
          // Moving back to item, keep header white
          setHeaderBackground(true);
          return;
        }
      }
      
      // Check if mouse is still within panel (moving between panel children)
      if (event && event.relatedTarget) {
        if (panel === event.relatedTarget || panel.contains(event.relatedTarget)) {
          // Still in panel, keep header white
          setHeaderBackground(true);
          return;
        }
      }
      
      // Add delay before closing to allow mouse to move back to item or panel
      if (mouseLeaveTimeout) {
        clearTimeout(mouseLeaveTimeout);
      }
      
      mouseLeaveTimeout = setTimeout(() => {
        // Check if mouse is now over item or panel
        if (isMouseOverItem || isMouseOverPanel) {
          setHeaderBackground(true);
          return;
        }
        
        // Check current mouse position
        if (event) {
          const elementUnderMouse = document.elementFromPoint(event.clientX, event.clientY);
          if (elementUnderMouse && (panel.contains(elementUnderMouse) || item.contains(elementUnderMouse))) {
            setHeaderBackground(true);
            return;
          }
        }
        
        // Mouse has truly left both item and panel - close menu and set header transparent
        // CRITICAL: Set header transparent BEFORE closing to prevent white flash
        // Keep panel-has-focus class - it will be removed when another item is selected
        setHeaderBackground(false);
        closeItem(item);
        if (openItem === item) {
          openItem = null;
        }
        mouseLeaveTimeout = null;
      }, 300); // Increased delay to allow mouse movement
    });
    
    // CRITICAL: Also listen for mouseout on panel - fires when mouse leaves panel or any child
    panel.addEventListener('mouseout', (event) => {
      if (!isDesktop()) return;
      console.log('Panel mouseout:', { 
        relatedTarget: event.relatedTarget?.tagName, 
        target: event.target?.tagName,
        item: item.tagName 
      });
      
      // Check if mouse is moving to item
      if (event.relatedTarget && (item === event.relatedTarget || item.contains(event.relatedTarget))) {
        console.log('Panel mouseout: Moving to item, not closing');
        return; // Moving to item, don't close
      }
      // Check if mouse is still within panel
      if (event.relatedTarget && (panel === event.relatedTarget || panel.contains(event.relatedTarget))) {
        console.log('Panel mouseout: Still in panel, not closing');
        return; // Still in panel, don't close
      }
      
      console.log('Panel mouseout: Mouse left panel, scheduling close');
      
      // Mouse left panel and not going to item - close after short delay
      if (mouseLeaveTimeout) {
        clearTimeout(mouseLeaveTimeout);
      }
      mouseLeaveTimeout = setTimeout(() => {
        // Final check: is mouse over item or panel?
        const currentElement = document.elementFromPoint(event.clientX, event.clientY);
        if (currentElement) {
          const stillOverItem = item === currentElement || item.contains(currentElement);
          const stillOverPanel = panel === currentElement || panel.contains(currentElement);
          if (stillOverItem || stillOverPanel) {
            console.log('Panel mouseout: Mouse is back over item/panel, canceling close');
            return; // Mouse is back, don't close
          }
        }
        console.log('Panel mouseout: Closing menu');
        // CRITICAL: Set header transparent BEFORE closing to prevent white flash
        setHeaderBackground(false);
        closeItem(item);
        if (openItem === item) {
          openItem = null;
        }
        mouseLeaveTimeout = null;
      }, 150);
    });

    trigger.addEventListener('click', (event) => {
      if (!isDesktop()) {
        return;
      }
      const hasSubmenu = trigger.getAttribute('data-has-submenu') === 'true';
      if (!hasSubmenu) {
        return;
      }
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      const isKeyboardEvent = event.detail === 0;
      if (!isExpanded) {
        event.preventDefault();
        openItemFn(item, false);
      } else if (isKeyboardEvent) {
        event.preventDefault();
        return;
      }
    });

    trigger.addEventListener('keydown', (event) => handleTriggerKeydown(event, item));

    // ADA-compliant keyboard navigation: Use a single event listener on the panel
    // This is more efficient and reliable than attaching to individual elements
    // CRITICAL: Initialize these flags BEFORE adding event listeners to ensure they're ready
    let isNavigatingWithKeyboard = false;
    let keyboardNavigationTimeout = null;
    
    // Set up keyboard navigation flag BEFORE focusout handler to prevent menu closing on initial load
    panel.addEventListener('keydown', (event) => {
      // Only handle navigation keys when focus is within the panel
      if (panel.contains(document.activeElement)) {
        // Tab: explicitly walk panel links (panel lives in <body>, so we cannot
        // rely on the browser's natural tab order). Always preventDefault and
        // move focus ourselves so the focusout close logic never races.
        if (event.key === 'Tab') {
          const focusable = getPanelFocusableElements(panel);
          if (!focusable.length) return;

          const current = document.activeElement;
          const idx = focusable.indexOf(current);

          // Flag keyboard navigation so focusout doesn't close the panel mid-move
          isNavigatingWithKeyboard = true;
          if (keyboardNavigationTimeout) {
            clearTimeout(keyboardNavigationTimeout);
          }
          keyboardNavigationTimeout = setTimeout(() => {
            isNavigatingWithKeyboard = false;
          }, 2000);

          event.preventDefault();
          event.stopPropagation();

          if (event.shiftKey) {
            if (idx <= 0) {
              // Before first link → back to the trigger
              trigger.focus();
            } else {
              focusable[idx - 1].focus();
            }
          } else if (idx === -1) {
            focusable[0].focus();
          } else if (idx < focusable.length - 1) {
            focusable[idx + 1].focus();
          } else {
            // Past the last link → close and advance to next header item
            isNavigatingWithKeyboard = false;
            if (keyboardNavigationTimeout) {
              clearTimeout(keyboardNavigationTimeout);
              keyboardNavigationTimeout = null;
            }
            closeItem(item);
            announceNavMenu('Submenu closed');
            if (openItem === item) {
              openItem = null;
            }
            const navFocusables = getHeaderNavFocusables();
            const triggerIdx = navFocusables.indexOf(trigger);
            if (triggerIdx >= 0 && triggerIdx < navFocusables.length - 1) {
              navFocusables[triggerIdx + 1].focus();
            }
          }
          return;
        }
        
        // Mark that we're navigating with keyboard to prevent focusout from closing
        // CRITICAL: Set flag IMMEDIATELY and synchronously before any async operations
        if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          // CRITICAL: Set flag IMMEDIATELY before anything else
          // This must happen synchronously before handlePanelKeydown moves focus
          isNavigatingWithKeyboard = true;
          // Clear any existing timeout
          if (keyboardNavigationTimeout) {
            clearTimeout(keyboardNavigationTimeout);
            keyboardNavigationTimeout = null;
          }
          
          // Prevent default and handle navigation
          event.preventDefault();
          event.stopPropagation();
          
          // CRITICAL: Handle navigation which will move focus
          // The focusout event will fire when focus moves, but the flag is already set
          handlePanelKeydown(event, item, trigger);
          
          // CRITICAL: Keep flag true for a longer period to handle rapid navigation
          // Don't clear it immediately - let the focusout handler manage it
          // Use a longer timeout as backup
          keyboardNavigationTimeout = setTimeout(() => {
            // Only clear if we're sure focus has left
            const activeElement = document.activeElement;
            const header = getHeader();
            
            // Check if focus is still within panel or item
            if (panel.contains(activeElement) || item.contains(activeElement)) {
              // Focus is still within panel/item - keep class and flag, extend timeout
              item.classList.add('panel-has-focus');
              // Extend the timeout again
              if (keyboardNavigationTimeout) {
                clearTimeout(keyboardNavigationTimeout);
              }
              keyboardNavigationTimeout = setTimeout(() => {
                isNavigatingWithKeyboard = false;
              }, 2000);
              return;
            }
            
            // Check if focus moved to another menu item
            if (header) {
              const allMenuItems = Array.from(header.querySelectorAll('[data-megamenu-item]'));
              const activeItem = allMenuItems.find(menuItem => menuItem.contains(activeElement));
              if (activeItem && activeItem !== item) {
                // Focus moved to another menu item - clear flag and remove class
                isNavigatingWithKeyboard = false;
                item.classList.remove('panel-has-focus');
                return;
              }
            }
            
            // Check if focus is still in header (might tab back)
            if (header && header.contains(activeElement)) {
              // Still in header - keep class for now, extend timeout
              if (keyboardNavigationTimeout) {
                clearTimeout(keyboardNavigationTimeout);
              }
              keyboardNavigationTimeout = setTimeout(() => {
                isNavigatingWithKeyboard = false;
              }, 2000);
              return;
            }
            
            // Focus has truly left - clear flag
            // Don't remove panel-has-focus here - it should stay until another item is selected
            isNavigatingWithKeyboard = false;
          }, 2000);
        } else {
          // For other keys, just handle normally
          handlePanelKeydown(event, item, trigger);
        }
      }
    });
    
    // CRITICAL: Track when panel has focus to keep top-level menu item styled
    // The class should be present whenever the panel is open, regardless of focus location
    // But we don't remove it when panel closes - it stays until another item is selected
    const ensurePanelHasFocusClass = () => {
      const isOpen = item.classList.contains('is-open') || item.classList.contains('open');
      if (isOpen && !item.classList.contains('panel-has-focus')) {
        // Only add if not already present to avoid triggering MutationObserver
        item.classList.add('panel-has-focus');
      }
      // Don't remove when panel closes - class stays until another item is selected
    };
    
    // Ensure class is present whenever panel is open
    // Use MutationObserver to watch for class changes on the item, but debounce to avoid loops
    let observerTimeout = null;
    const observer = new MutationObserver((mutations) => {
      // Debounce to avoid infinite loops
      if (observerTimeout) {
        clearTimeout(observerTimeout);
      }
      observerTimeout = setTimeout(() => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Check if the change was adding/removing is-open or open, not panel-has-focus
            const target = mutation.target;
            const hadOpen = mutation.oldValue && (mutation.oldValue.includes('is-open') || mutation.oldValue.includes('open'));
            const hasOpen = target.classList.contains('is-open') || target.classList.contains('open');
            if (hadOpen !== hasOpen) {
              // Only update if is-open/open state changed, not if panel-has-focus changed
              ensurePanelHasFocusClass();
            }
          }
        });
      }, 10);
    });
    observer.observe(item, { 
      attributes: true, 
      attributeFilter: ['class'],
      attributeOldValue: true // Track old value to detect what changed
    });
    
    panel.addEventListener('focusin', (event) => {
      // Panel or its children have focus - ensure header stays white
      // panel-has-focus class is already set when item was selected - don't need to add again
      setHeaderBackground(true);
    });
    
    panel.addEventListener('focusout', (event) => {
      // CRITICAL: Check keyboard flag FIRST (before any other checks)
      // This is the most reliable way to prevent closing during arrow key navigation
      // Check this synchronously before any async operations
      if (isNavigatingWithKeyboard) {
        // Keep flag true - don't clear it here, let it persist for rapid navigation
        // The flag will be cleared when focus truly leaves or after timeout
        // panel-has-focus class is already set - don't need to add again
        return;
      }
      
      // CRITICAL: Check relatedTarget immediately (synchronously) to see if focus is moving within panel
      // This prevents menu from closing when arrow keys move focus between items
      if (event.relatedTarget && (panel.contains(event.relatedTarget) || item.contains(event.relatedTarget))) {
        // Focus is moving to another element within panel/item - don't close
        // Also set the keyboard flag since we're navigating within the panel
        isNavigatingWithKeyboard = true;
        // Clear any existing timeout and set a new one
        if (keyboardNavigationTimeout) {
          clearTimeout(keyboardNavigationTimeout);
        }
        keyboardNavigationTimeout = setTimeout(() => {
          isNavigatingWithKeyboard = false;
        }, 2000);
        return;
      }
      
      // CRITICAL: Also check if focus is moving from one panel element to another
      // This handles the case where relatedTarget might be null but focus is still in panel
      // Use a microtask to check after the current event loop
      Promise.resolve().then(() => {
        const activeElement = document.activeElement;
        if (panel.contains(activeElement) || item.contains(activeElement)) {
          // Focus is still within panel/item - don't close
          // Also set the keyboard flag since we're navigating within the panel
          isNavigatingWithKeyboard = true;
          // Clear any existing timeout and set a new one
          if (keyboardNavigationTimeout) {
            clearTimeout(keyboardNavigationTimeout);
          }
          keyboardNavigationTimeout = setTimeout(() => {
            isNavigatingWithKeyboard = false;
          }, 2000);
          return;
        }
      });
      
      // Check if focus is still within panel/item/header menu area after a short delay
      // This handles the case where focus moves between elements in the panel
      setTimeout(() => {
        const activeElement = document.activeElement;
        const header = getHeader();
        
        // Check if focus moved to another menu item in the header
        if (header) {
          const allMenuItems = Array.from(header.querySelectorAll('[data-megamenu-item]'));
          const activeItem = allMenuItems.find(menuItem => menuItem.contains(activeElement));
          if (activeItem && activeItem !== item) {
            // Focus moved to another menu item - remove class from this item
            // The new item will get the class when it receives focus
            item.classList.remove('panel-has-focus');
            return;
          }
        }
        
        // Check if focus is still within the item or panel
        if (item.contains(activeElement) || (panel && panel.contains(activeElement))) {
          // Still in item or panel - keep panel-has-focus class
          return;
        }
        
        // Focus has left the item and panel - but don't remove class yet
        // It will be removed when focus leaves header entirely or another item is selected
      }, 0);
      
      // CRITICAL: Don't close if focus is moving to another element within the panel
      // Use requestAnimationFrame to check after focus has moved
      requestAnimationFrame(() => {
        // Double-check the flag in case it was set during the frame
        if (isNavigatingWithKeyboard) {
          return;
        }
        
        // Check if focus is now within the panel or item
        const activeElement = document.activeElement;
        if (panel.contains(activeElement) || item.contains(activeElement)) {
          // Focus is still within menu, don't close
          return;
        }
        
        // Only close if focus is truly leaving both item and panel
        // Double-check the relatedTarget again
        if (event.relatedTarget && (panel.contains(event.relatedTarget) || item.contains(event.relatedTarget))) {
          return;
        }
        
        // Double-check one more time with a small delay to catch rapid navigation
        setTimeout(() => {
          if (isNavigatingWithKeyboard) {
            return;
          }
          
          const activeElementCheck = document.activeElement;
          if (panel.contains(activeElementCheck) || item.contains(activeElementCheck)) {
            return;
          }
          
          // Focus has truly left - clear keyboard flag and close menu
          // Don't remove panel-has-focus here - it should stay until another item is selected
          isNavigatingWithKeyboard = false;
          if (keyboardNavigationTimeout) {
            clearTimeout(keyboardNavigationTimeout);
            keyboardNavigationTimeout = null;
          }
          closeItem(item);
          if (openItem === item) {
            openItem = null;
          }
        }, 100);
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!openItem) {
      return;
    }
    
    const clickTarget = event.target;
    const isClickInItem = openItem.contains(clickTarget);
    const trigger = openItem.querySelector('[data-megamenu-trigger]');
    const panelId = trigger ? trigger.getAttribute('aria-controls') : null;
    const panel = panelId ? document.getElementById(panelId) : null;
    const isClickInPanel = panel && panel.contains(clickTarget);
    
    // CRITICAL: If click is on a link in the menu/flyout, remove panel-has-focus class
    // This handles navigation - when user selects a value, the indicator should disappear
    if (isClickInPanel || isClickInItem) {
      const clickedLink = clickTarget.closest('a[href]');
      if (clickedLink && clickedLink.href && clickedLink.href !== '#' && clickedLink.href !== window.location.href && !clickedLink.href.endsWith('#')) {
        // User clicked a link - remove panel-has-focus class
        openItem.classList.remove('panel-has-focus');
      }
    }
    
    // If click is outside both item and panel, close the menu
    if (!isClickInItem && !isClickInPanel) {
      setHeaderBackground(false);
      closeItem(openItem);
      openItem = null;
    }
  });
  
  // CRITICAL: Listen for mouseleave on document to catch when mouse leaves both item and panel
  // Since panel is in body, we need to track mouse position globally
  document.addEventListener('mouseleave', (event) => {
    if (!isDesktop() || !openItem) return;
    // Mouse left the document/viewport, close menu and set header transparent
    const itemToClose = openItem;
    setHeaderBackground(false);
    closeItem(itemToClose);
    if (openItem === itemToClose) {
      openItem = null;
    }
  });
  
  // Also use a simpler approach: listen for mouseout on the panel itself
  // This should fire when mouse leaves the panel
  // We'll set this up in the forEach loop below
  
  // Set header background to white when search input is focused
  function setupSearchInputListeners() {
    const searchInputs = document.querySelectorAll('#header-search-input, #header-search-input-mobile, .header-search-input, .header-search-input-mobile');
    searchInputs.forEach((searchInput) => {
      // Skip if already has listener (check for a data attribute)
      if (searchInput.dataset.searchListenerAdded) return;
      searchInput.dataset.searchListenerAdded = 'true';
      
      searchInput.addEventListener('focus', () => {
        setHeaderBackground(true);
      });
      
      searchInput.addEventListener('blur', () => {
        // Use a small delay to check if focus is truly outside all search inputs
        // This handles mobile cases where blur might fire before focus moves (transparent header fix)
        setTimeout(() => {
          // Only revert to transparent if no menu is open and no other search input/form is focused
          const anyMenuOpen = Array.from(document.querySelectorAll('[data-megamenu-item]')).some((item) => {
            return item.classList.contains('is-open') || item.classList.contains('open');
          });
          
          const anySearchFocused = Array.from(document.querySelectorAll('#header-search-input, #header-search-input-mobile, .header-search-input, .header-search-input-mobile')).some((input) => {
            return input === document.activeElement;
          });
          
          // Check if any search form still has focus-within
          const anySearchFormFocused = Array.from(document.querySelectorAll('.header-search-form, .header-search-form-mobile')).some((form) => {
            return form.matches(':focus-within') || form.contains(document.activeElement);
          });
          
          if (!anyMenuOpen && !anySearchFocused && !anySearchFormFocused) {
            setHeaderBackground(false);
          }
        }, 100); // Small delay to allow focus to settle
      });
    });
    
    // Also handle focus-within on the search form for better detection
    const searchForms = document.querySelectorAll('.header-search-form, .header-search-form-mobile');
    searchForms.forEach((searchForm) => {
      // Skip if already has listener
      if (searchForm.dataset.searchListenerAdded) return;
      searchForm.dataset.searchListenerAdded = 'true';
      
      searchForm.addEventListener('focusin', () => {
        setHeaderBackground(true);
      });
      
      searchForm.addEventListener('focusout', (e) => {
        // Check if focus is moving to another element within the search form
        if (e.relatedTarget && searchForm.contains(e.relatedTarget)) {
          return; // Focus is still within the form, keep white background
        }
        
        // Use a small delay to check if focus is truly outside the form
        // This handles mobile cases where relatedTarget might be null
        setTimeout(() => {
          // Check if the form still has focus-within (any child element is focused)
          const formHasFocus = searchForm.matches(':focus-within') || searchForm.contains(document.activeElement);
          
          // Only revert if no menu is open, form doesn't have focus, and no search input is focused
          const anyMenuOpen = Array.from(document.querySelectorAll('[data-megamenu-item]')).some((item) => {
            return item.classList.contains('is-open') || item.classList.contains('open');
          });
          
          const anySearchFocused = Array.from(document.querySelectorAll('#header-search-input, #header-search-input-mobile, .header-search-input, .header-search-input-mobile')).some((input) => {
            return input === document.activeElement;
          });
          
          // Check if any search form still has focus-within
          const anySearchFormFocused = Array.from(document.querySelectorAll('.header-search-form, .header-search-form-mobile')).some((form) => {
            return form.matches(':focus-within') || form.contains(document.activeElement);
          });
          
          if (!anyMenuOpen && !anySearchFocused && !anySearchFormFocused && !formHasFocus) {
            setHeaderBackground(false);
          }
        }, 100); // Small delay to allow focus to settle
      });
    });
  }
  
  // Set up listeners immediately
  setupSearchInputListeners();
  
  // Also set up listeners after a short delay to catch any dynamically added inputs
  setTimeout(setupSearchInputListeners, 100);
}

function initMegaMenu() {
  // CRITICAL: Move ALL panels to body immediately, before setup
  // This must happen as early as possible to ensure panels are never in header
  function movePanelsToBody() {
    const allPanels = document.querySelectorAll('.megamenu, [data-megamenu-panel], [id*="-panel"]');
    console.log('initMegaMenu: Found', allPanels.length, 'panels');
    allPanels.forEach((panel) => {
      // Skip filter accordion panels - they should stay in their containers
      // Filter panels have IDs like "collections-type-panel", "collections-sport-panel", etc.
      if (panel.id && (panel.id.startsWith('collections-') || panel.id.includes('-panel-mobile'))) {
        return; // Skip filter panels - don't move them
      }
      
      const currentParent = panel.parentElement;
      if (currentParent !== document.body) {
        // Store original parent
        if (!panel.dataset.originalParent) {
          panel.dataset.originalParent = currentParent.tagName + (currentParent.className ? '.' + currentParent.className.split(' ')[0] : '');
        }
        // Force remove from current parent
        if (currentParent) {
          currentParent.removeChild(panel);
        }
        // Move to body immediately
        document.body.appendChild(panel);
        console.log('initMegaMenu: Moved panel', panel.id || 'no-id', 'to body. Original parent:', panel.dataset.originalParent);
        
        // CRITICAL: Set initial styles to ensure it's fixed and hidden
        panel.style.cssText = 'position: fixed !important; display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important; left: 0 !important; right: 0 !important; transform: none !important;';
      } else {
        console.log('initMegaMenu: Panel', panel.id || 'no-id', 'already in body');
      }
    });
  }
  
  // Run immediately if DOM is ready
  if (document.body) {
    movePanelsToBody();
  }
  
  // Also run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      movePanelsToBody();
      setupMegaMenu();
    });
  } else {
    setupMegaMenu();
  }
}

// Run immediately
initMegaMenu();

// Also run on DOMContentLoaded to catch any panels added later
document.addEventListener('DOMContentLoaded', () => {
  const allPanels = document.querySelectorAll('.megamenu, [data-megamenu-panel], [id*="-panel"]');
  allPanels.forEach((panel) => {
    // Skip filter accordion panels - they should stay in their containers
    // Filter panels have IDs like "collections-type-panel", "collections-sport-panel", etc.
    if (panel.id && (panel.id.startsWith('collections-') || panel.id.includes('-panel-mobile'))) {
      return; // Skip filter panels - don't move them
    }
    
    // Skip Yotpo panels - they should stay in their containers
    if (panel.id && (panel.id.includes('yotpo') || panel.id.includes('Yotpo') || panel.classList.contains('yotpo'))) {
      return; // Skip Yotpo panels - don't move them
    }
    
    // Skip footer accordion panels - they should stay in footer
    if (panel.id && panel.id.startsWith('footer-accordion-')) {
      return; // Skip footer accordions - don't move them
    }
    
    // Skip any accordion-body elements - they should stay in their containers
    if (panel.classList.contains('accordion-body')) {
      return; // Skip accordion bodies - don't move them
    }
    
    if (panel.parentElement !== document.body) {
      const currentParent = panel.parentElement;
      if (currentParent) {
        currentParent.removeChild(panel);
      }
      document.body.appendChild(panel);
      console.log('DOMContentLoaded: Moved panel', panel.id || 'no-id', 'to body');
    }
  });
});

// CRITICAL: Watch for panels being moved back to header (shouldn't happen, but catch it)
const panelObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { // Element node
        // Check if this is a megamenu panel
        if (node.matches && (node.matches('.megamenu, [data-megamenu-panel], [id*="-panel"]') || 
            node.classList?.contains('megamenu'))) {
          // Skip filter accordion panels - they should stay in their containers
          // Filter panels have IDs like "collections-type-panel", "collections-sport-panel", etc.
          if (node.id && (node.id.startsWith('collections-') || node.id.includes('-panel-mobile'))) {
            // Skip filter panels - don't move them
            return;
          }
          
          // Skip Yotpo panels - they should stay in their containers
          if (node.id && (node.id.includes('yotpo') || node.id.includes('Yotpo') || node.classList.contains('yotpo'))) {
            // Skip Yotpo panels - don't move them
            return;
          }
          
          // Skip footer accordion panels - they should stay in footer
          if (node.id && node.id.startsWith('footer-accordion-')) {
            // Skip footer accordions - don't move them
            return;
          }
          
          // Skip any accordion-body elements - they should stay in their containers
          if (node.classList.contains('accordion-body')) {
            // Skip accordion bodies - don't move them
            return;
          }
          
          if (node.parentElement !== document.body) {
            console.warn('PanelObserver: Panel', node.id || 'no-id', 'was added to', node.parentElement?.tagName, '- moving to body');
            const parent = node.parentElement;
            if (parent) {
              parent.removeChild(node);
            }
            document.body.appendChild(node);
          }
        }
        // Also check children
        const panels = node.querySelectorAll && node.querySelectorAll('.megamenu, [data-megamenu-panel], [id*="-panel"]');
        if (panels) {
          panels.forEach((panel) => {
            // Skip filter accordion panels - they should stay in their containers
            // Filter panels have IDs like "collections-type-panel", "collections-sport-panel", etc.
            if (panel.id && (panel.id.startsWith('collections-') || panel.id.includes('-panel-mobile'))) {
              return; // Skip filter panels
            }
            
            // Skip Yotpo panels - they should stay in their containers
            if (panel.id && (panel.id.includes('yotpo') || panel.id.includes('Yotpo') || panel.classList.contains('yotpo'))) {
              return; // Skip Yotpo panels
            }
            
            // Skip footer accordion panels - they should stay in footer
            if (panel.id && panel.id.startsWith('footer-accordion-')) {
              return; // Skip footer accordions
            }
            
            // Skip any accordion-body elements - they should stay in their containers
            if (panel.classList.contains('accordion-body')) {
              return; // Skip accordion bodies
            }
            
            if (panel.parentElement !== document.body) {
              console.warn('PanelObserver: Panel', panel.id || 'no-id', 'found in', panel.parentElement?.tagName, '- moving to body');
              const parent = panel.parentElement;
              if (parent) {
                parent.removeChild(panel);
              }
              document.body.appendChild(panel);
            }
          });
        }
      }
    });
  });
});

// Observe body for any panels being added
if (document.body) {
  panelObserver.observe(document.body, { childList: true, subtree: true });
}

// Also observe document for panels added anywhere
panelObserver.observe(document.documentElement, { childList: true, subtree: true });

// CRITICAL: Initialize footer accordion states on page load
// Ensure all footer accordions start closed and have correct state
function initializeFooterAccordions() {
  const footerAccordions = document.querySelectorAll('.js-trigger.accordion[aria-controls^="footer-accordion-"]');
  footerAccordions.forEach(function(button) {
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    
    // Force button to closed state
    button.setAttribute('aria-expanded', 'false');
    button.classList.remove('open');
    button.dataset.accordionState = 'false';
    
    // Force panel to closed state
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.style.setProperty('display', 'none', 'important');
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFooterAccordions);
} else {
  initializeFooterAccordions();
}

// Also initialize after a short delay to catch any late-loading content
setTimeout(initializeFooterAccordions, 500);
